import { Zap } from "lucide-react";
import { useTranslation } from "react-i18next";

import { useReadOnly } from "../lock/ReadOnlyContext";
import { downloadDealSummaryPdf } from "./api/downloadDealSummaryPdf";
import FabPopover from "./FabPopover";
import { MOCK_ACTION_ITEMS } from "./mockData";

export const ACTIONS_PANEL_ID = "actions-panel";

type ActionsPopoverProperties = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  approvalId: string;
};

function ActionsPopover({ open, onOpenChange, approvalId }: ActionsPopoverProperties) {
  const { t } = useTranslation();
  const readOnly = useReadOnly();

  const handleActionClick = async (actionId: string) => {
    onOpenChange(false);

    if (actionId === "print-step5") {
      try {
        await downloadDealSummaryPdf(approvalId);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Failed to download PDF:", error);
      }
    }
  };

  return (
    <FabPopover
      label={t("actions.menu")}
      icon={<Zap className="size-6" />}
      variant="navy"
      panelId={ACTIONS_PANEL_ID}
      open={open}
      onOpenChange={onOpenChange}
      disabled={readOnly}
      contentClassName="w-56 p-1"
    >
      <ul role="menu" aria-label={t("actions.menu")}>
        {MOCK_ACTION_ITEMS.map((item) => (
          <li key={item.id} role="none">
            <button
              type="button"
              role="menuitem"
              className="hover:bg-accent focus-visible:bg-accent text-foreground w-full rounded-sm px-3 py-2 text-left text-sm outline-none transition-colors"
              onClick={() => handleActionClick(item.id)}
            >
              {item.label}
            </button>
          </li>
        ))}
      </ul>
    </FabPopover>
  );
}

export default ActionsPopover;
